import React from 'react';
import courseService from '../services/courseService';

const CourseCard = ({ course, onViewDetails, onEnroll }) => {
    const summary = courseService.stripHtml(course.summary || 'No description available');
    const shortName = course.shortname || 'N/A';

    return (
        <div className="course-card">
            <div className="course-title">{course.fullname || 'Untitled Course'}</div>
            <div className="course-summary">{summary}</div>
            
            <div className="course-meta">
                <span className="meta-item">
                    <strong>Course ID:</strong> {course.id}
                </span>
                <span className="meta-item">
                    <strong>Code:</strong> {shortName}
                </span>
                <span className="payfast-badge">
                    💳 PayFast Available
                </span>
                <span className="meta-item">
                    <strong>Format:</strong> {course.format || 'Standard'}
                </span>
            </div>

            <div className="course-actions">
                <button 
                    onClick={() => onViewDetails(course.id)} 
                    className="btn btn-primary"
                >
                    📋 View Details
                </button>
                <button 
                    onClick={() => onEnroll(course.id)} 
                    className="btn btn-secondary"
                >
                    💳 Enroll Now
                </button>
            </div>
        </div>
    );
};

export default CourseCard;
